var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#FF8604",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m438-326.77 152.15-152.15q9.85-9.85 22.5-10.23 12.66-.39 23.27 10.23 10.62 10.61 10.62 22.88t-10.62 22.89l-166.3 166.3q-13.52 13.7-31.53 13.7t-31.71-13.7l-80.3-80.3q-9.85-9.85-9.73-22.5.11-12.66 10.73-23.27 10.61-10.62 22.88-10.62t22.89 10.62L438-326.77ZM218.62-90q-38.35 0-64.48-26.14Q128-142.27 128-180.62v-522.76q0-38.35 26.14-64.48Q180.27-794 218.62-794h38.76v-50.69q0-14.31 10.12-24.43 10.12-10.11 24.42-10.11 14.31 0 24.43 10.11 10.11 10.12 10.11 24.43V-794h310.16v-52.23q0-13.54 9.73-23.27t23.27-9.73q13.53 0 23.26 9.73 9.74 9.73 9.74 23.27V-794h38.76q38.35 0 64.48 26.14Q832-741.73 832-703.38v522.76q0 38.35-26.14 64.48Q779.73-90 741.38-90H218.62Zm0-66h522.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-374.76H194v374.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.99fdecca653bea9ac5cde543fd871cdd.svg";